import { AnnotationAction } from "../actions";
import { ActionTypes } from "../const/ActionTypes";
import { AnnotationItemExtended } from "../types";

export type AnnotationState = AnnotationItemExtended;

export const annotationReducer = (state: AnnotationState = {}, action: AnnotationAction): AnnotationState => {
    switch (action.type) {
        case ActionTypes.SET_ANNOTATION:
            return { ...action.value };
        case ActionTypes.CLEAR_ANNOTATION:
            return {};
        case ActionTypes.ENTER_EDIT_MODE:
            return {
                ...action.value,
                ...{
                    selection: {
                        ...action.value.selection,
                        showEditor: true,
                        mode: "EDITING",
                    },
                },
            };
        case ActionTypes.ENTER_VIEW_MODE:
            return {
                ...action.value,
                ...{
                    selection: undefined,
                },
            };
        default:
            return state;
    }
};
